import api from '../api';


export interface ToggleChangeEventDetail<T = any> {
  value: T;
  checked: boolean;
}

export interface IError {
  error: string;
}


export interface ResponseGenerica<T> {
  datos: T[],
  error?: string
}
export interface IfetchPuntoServicio {
  ps_nombre: string;
  ps_codigo: string;
  estado: number;
  objeto: number;
  id: number;
  // TD-11079: true si la unidad de negocio del PS maneja pedidos de EPIs (GENTIS)
  maneja_epi?: boolean;
}

export interface IDetallePedido {
  tolerado_restante: number;
  cabecera: any;
  error?: string;
  estado: number;
  excedente: number;
  facturar: boolean;
  fecha: string;
  fiscal: string;
  id: number;
  comodato?: boolean | number;
  nuevo_ingreso?: number | boolean;
  num_pre: null;
  precio_total: number;
  ps_nombre: string;
  ps_objeto: string;
  tolerado: number;
}

interface IProductoBase {
  cantidad: number;
  precio_unitario: number;
  prod_descripcion: string;
  prod_nombre: string;
}
export interface IProductoInventarioDatos extends IProductoBase {
  id: any;
  precio: number;
  error?: boolean;
  activo?: number;
  enviado?: number;
  item_cod: string;
  item_desc: string;
  item_stock: number;
  stock: number;
  // Datos de la última fiscalización del PS: la cantidad contada se usa como
  // precarga de la cantidad a pedir.
  cantidad_precarga?: number;
  fis_porcentaje?: number;
  fis_id?: number;
  fis_fecha?: string;
  // De dónde salió la línea en un pedido nuevo: de la fiscalización (con cantidad)
  // o del último remito de BC (sin cantidad).
  origen_lista?: "FISCALIZACION" | "ULTIMO_PEDIDO";
}

export interface IProductoList extends IProductoInventarioDatos {
  cantidad: number;
  precio_unitario: number;
  prod_descripcion: string;
  prod_nombre: string;

}


const API_URL_PUNTO_SERVICIO = `punto_servicio/todos`;
const API_URL_INICIAR_PEDIDO = `pedido-productos/iniciar-pedido`;
const API_URL_OBTENER_PEDIDO = `pedido-productos/pedido`;
const API_URL_API_BASE = `pedido-productos/pedido`;
const API_URL_OBTENER_PRODUCTO = `pedido-productos/obtener-item-producto`;
const API_URL_FECHA = `pedido-productos/fechas-pedidos/todos`
// NUEVO: endpoint para ver historial de eliminaciones por pedido
const API_URL_ELIMINACIONES = `pedido-productos/pedido` // Base para /{id_pc}/eliminaciones


export const fetchPuntoServicio = async (ps_nombre: string): Promise<ResponseGenerica<IfetchPuntoServicio>> => {
  try {
    const response = await api.get(`${API_URL_PUNTO_SERVICIO}?ps_nombre=${ps_nombre}`)

    const data: { datos: IfetchPuntoServicio[]; error?: string } = await response.data;

    if (data.error || response.status >= 300 || response.status <= 199 || !data.datos) {
      return {
        datos: [],
        error: data.error ?? 'Ocurrió un error al obtener los puntos de servicio.'
      };
    }

    return data;

  } catch (error) {
    console.error('Error:', error);
    return {
      datos: [],
      error: "Ocurrió un error al obtener los puntos de servicio."
    };
  }
}


export const fetchFechaPedidos = async () => {

  try {
    const response = await api.get(`${API_URL_FECHA}`);

    const data = response.data;
    console.log("fetchFechaPedidos data:", data);

    if (data.error || response.status >= 300 || response.status <= 199) {
      return {
        error: data.error ?? 'Ocurrió un error al consultar las fechas de Pedido de Productos'
      };

    } else if (data.datos.length === 0) {
      return {
        error: 'No hay fechas disponibles para la solicitud de pedidos'
      }
    }
    
    // Verificamos si la fecha actual está dentro de alguno de los rangos disponibles.
    const currentDate = new Date();
    const isActive = data.datos.some((fecha: any) => {
      const desde = new Date(fecha.fecha_desde.replace(" ", "T"));
      const hasta = new Date(fecha.fecha_hasta.replace(" ", "T"));
      return currentDate >= desde && currentDate <= hasta;
    });
    
    if (!isActive) {
      return {
        error: 'No hay fechas disponibles para la solicitud de pedidos'
      };
    }

    return data.datos;

  } catch(error) {
    return {
      error: 'No hay fechas disponibles para la solicitud de pedidos'
    };
  }

};


export const fetchIniciarPP = async (iniciar: any) => {

  try {
    const response = await api.post(`${API_URL_INICIAR_PEDIDO}`, iniciar);
    const data = await response.data;

    if (data.error || response.status >= 300 || response.status <= 199) {
      return {
        data: data,
        response: response,
        error: data.error.response.error ?? 'Ocurrió un error al iniciar el pedido.'
      };
    }
    return data;

  } catch (error: any) {
    // El backend devuelve 409 con { encuesta_pendiente, pedido, preguntas, error } cuando
    // el último pedido enviado del PS aún no tiene encuesta. Propagamos el body completo
    // para que el frontend abra el modal y bloquee hasta completarla.
    const body = error?.response?.data;
    if (body && body.encuesta_pendiente) {
      return body;
    }
    return {
      error: body?.error ?? 'Ocurrió un error al iniciar el pedido.'
    };
  }
};


export const fetchObtenerPedido = async (id_pc: number) => {
  try {
    const response = await api.get(`${API_URL_OBTENER_PEDIDO}/${id_pc}`);
    const data = response.data;

    if (response.status >= 300 || response.status <= 199) {
      return {
        error: data?.error ?? 'Ocurrió un error al obtener el pedido.'
      };
    }
    return data;
  } catch (error) {
    console.error('Error:', error);
    return {
      error: 'Ocurrió un error al obtener el pedido.'
    };
  }
};

export const fetchInventarioProducto = async (id_pc: number) => {
  console.log(id_pc, 'id_pc');
  try {
    const response = await api.get(`${API_URL_API_BASE}/${id_pc}/inventario`);
    const data = await response.data;
    if (response.status >= 300 || response.status <= 199) {
      return {
        error: data ?? 'Ocurrió un error al obtener el pedido.'
      };
    }
    return data;
  } catch (error: any) {
    console.error('Error:', error);
    return {
      error: 'Ocurrió un error al obtener el pedido.'
    };
  }
};

export const fetchObtenerProducto = async () => {

  try {
    const response = await api.get(`${API_URL_OBTENER_PRODUCTO}`);
    const data = await response.data;
    if (response.status >= 300 || response.status <= 199) {
      return {
        error: data ?? 'Ocurrió un error al obtener los productos.'
      };
    }
    return data;
  } catch (error: any) {
    console.error('Error:', error);
    return {
      error: 'Ocurrió un error al obtener  los productos.'
    };
  }
};

// NUEVO: interfaz para una eliminación auditada
export interface IEliminacionPP { // Estructura del registro de eliminación
  id: number; // Identificador del registro de auditoría
  pedido_cab: number; // ID del pedido cabecera
  id_producto: number | null; // ID del detalle de producto (si aplica)
  prod_nombre: string; // Código/nombre de producto
  cantidad: number; // Cantidad eliminada
  actor_usuario: number; // Usuario que ejecutó la eliminación
  actor_cargo: string; // Cargo del actor
  fecha_eliminacion: string; // Marca temporal (texto formateado desde backend)
}

// NUEVO: obtener historial de eliminaciones por pedido
export const fetchEliminacionesPedido = async (id_pc: number): Promise<IEliminacionPP[] | { error: string }> => { // Devuelve lista o error
  try { // Manejo de errores
    const response = await api.get(`${API_URL_ELIMINACIONES}/${id_pc}/eliminaciones`); // GET al endpoint de historial
    const data = await response.data; // Extrae payload
    if (response.status >= 300 || response.status <= 199) { // Valida status HTTP
      return { // Devuelve error estructurado
        error: data?.error ?? 'Ocurrió un error al obtener el historial de eliminaciones.' // Mensaje legible
      }; // Cierre del objeto error
    } // Cierre del if de error
    return data.datos as IEliminacionPP[]; // Lista de eliminaciones en caso de éxito
  } catch (error: any) { // Captura excepciones
    console.error('Error fetchEliminacionesPedido:', error); // Log en consola
    return { // Devuelve error genérico
      error: 'Ocurrió un error al obtener el historial de eliminaciones.' // Mensaje genérico
    }; // Cierre del objeto error
  } // Cierre de catch
}; // Cierre de la función

export const fetchProductoSolicitado = async (id_pc: number, incluirInactivos: boolean = false) => {
  try {
    const qs = incluirInactivos ? '?incluir_inactivos=1' : '';
    const response = await api.get(`${API_URL_API_BASE}/${id_pc}/productos-solicitados${qs}`);
    const data = await response.data;
    if (response.status >= 300 || response.status <= 199) {
      return {
        error: data ?? 'Ocurrió un error al obtener los productos.'
      };
    }
    return data;
  } catch (error: any) {
    console.error('Error:', error);
    return {
      error: 'Ocurrió un error al obtener  los productos.'
    };
  }
}

export const handlePostComments = async (id_pc, comentario) => {
  try {
    const response = await api.post(`pedido-productos/pedido/${id_pc}/comentarios/crear`, comentario);

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to post comment');
    }

    return response.data;
  } catch (error) {
    console.error('Error posting comment:', error);
    return null;
  }
};

export const handleFetchComments = async (id_pc) => {
  try {
    const response = await api.get(`pedido-productos/pedido/${id_pc}/comentarios/ver`);

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to fetch comments');
    }

    // Asegúrate de que los datos estén en la forma que esperas
    return response.data.datos; // Asegúrate de que la propiedad 'datos' es correcta
  } catch (error) {
    console.error('Error fetching comments:', error);
    return []; // Retorna un array vacío en caso de error
  }
};

export const fetchRealizarPedido = async (id_pc: number, pedido: any) => {
  console.log(pedido, ':------pedido')
  try {
    const response = await api.post(`pedido-productos/pedido/${id_pc}/solicitar-productos`, pedido);

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to submit order');
    }
    console.log(response.data, 'response.data axios');
    return response.data;
  } catch (error: any) {
    console.error('Error submitting order:', error);
    const errResp = error?.response?.data;
    if (errResp) {
      return errResp;
    }
    return { error: (error instanceof Error ? error.message : 'Error al realizar el pedido') };
  }
};

export const fetchRealizaModificacion = async (id_pc, pedido) => {
  console.log(typeof (pedido), ':------pedido');
  try {
    const response = await api({
      method: 'patch',
      url: `pedido-productos/gestion/${id_pc}/modificar`,
      data: pedido,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to submit order');
    }
    console.log(response.data, 'response.data axios');
    return response.data;
  } catch (error) {
    console.error('Error submitting order:', error);
    // Intentar devolver el body de error si está disponible para que el frontend lo muestre
    // Si no está disponible, devolver un objeto con mensaje genérico
    // (Evita retornar null para que el caller pueda mostrar feedback)
    // @ts-ignore
    const errResp = error?.response?.data;
    if (errResp) {
      return errResp;
    }
    return { error: (error instanceof Error ? error.message : 'Error al enviar la modificación') };
  }
};

export const fetchCabeceraDetalle = async (id_pc: number, incluirInactivos: boolean = false) => {
  try {
    const qs = incluirInactivos ? '?incluir_inactivos=1' : '';
    const response = await api.get(`pedido-productos/pedido/${id_pc}/ver${qs}`);

    if (response.status >= 300 || response.status <= 199) {
      return {
        error: response.data ?? 'Ocurrió un error al obtener los productos.'
      };
    }
    console.log(response.data, 'response.data axios');
    return response.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    return null;
  }
};

// antes: export async function fetchMisPedidos() { ... }
// Al enviar 'pagina' el backend pagina la respuesta y agrega total/paginas.
export async function fetchMisPedidos(opts?: {
  limite?: number;
  ps?: string;
  fecha_desde?: string;
  fecha_hasta?: string;
  pagina?: number;
  estado?: number;
}) {
  const p = new URLSearchParams();
  if (opts?.limite != null) p.append("limite", String(opts.limite));
  if (opts?.ps) p.append("ps", opts.ps);
  if (opts?.fecha_desde) p.append("fecha_desde", opts.fecha_desde);
  if (opts?.fecha_hasta) p.append("fecha_hasta", opts.fecha_hasta);
  if (opts?.pagina != null) p.append("pagina", String(opts.pagina));
  if (opts?.estado != null) p.append("estado", String(opts.estado));
  const qs = p.toString();
  const url = qs ? `pedido-productos/mis-pedidos?${qs}` : `pedido-productos/mis-pedidos`;
  const { data } = await api.get(url);
  return data;
}

export interface IEstadoPedido {
  id: number;
  estado: string;
}

export const fetchEstadosPedido = async (): Promise<IEstadoPedido[]> => {
  try {
    const { data } = await api.get('pedido-productos/estados-pedidos');

    return data?.datos ?? [];
  } catch (error) {
    console.error('Error al obtener los estados de pedido:', error);

    return [];
  }
};

// NUEVO: obtener último pedido real (BC/Proactif) por PS
export interface IUltimoPedidoRealCabecera {
  document_no: string;
  order_no: string;
  posting_date: string;
  shipment_date: string;
  bill_to_customer_no: string;
  ps_objeto: string;
  ship_to_code: string;
}

// Línea del último remito de BC (para ofrecerla en el pedido sin cantidad)
export interface IUltimoPedidoRealItem {
  item_no: string;
  descripcion: string;
  cantidad: number;
}

export interface IUltimoPedidoRealResponse {
  cabecera: IUltimoPedidoRealCabecera | null;
  mapa: Record<string, number>;
  items?: IUltimoPedidoRealItem[];
}

export async function fetchUltimoPedidoReal(psObjeto: string): Promise<IUltimoPedidoRealResponse> {
  try {
    const params = new URLSearchParams({ ps_objeto: psObjeto });
    const { data } = await api.get(`pedido-productos/ultimo-pedido-real?${params.toString()}`);
    return (data?.datos as IUltimoPedidoRealResponse) ?? { cabecera: null, mapa: {}, items: [] };
  } catch (_) {
    return { cabecera: null, mapa: {}, items: [] };
  }
}

// Mantener compatibilidad: sólo el mapa por producto
export async function fetchUltimoPedidoMapa(psObjeto: string): Promise<Record<string, number>> {
  const resp = await fetchUltimoPedidoReal(psObjeto);
  return resp?.mapa || {};
}


// Stock disponible del ciclo: stock de BC (se sincroniza cada 2 hs) menos lo que ya
// piden los otros pedidos del mes en aprobación o enviados. Es informativo; el
// control que manda lo hace el backend al solicitar.
export interface IStockProducto {
  stock: number;
  reservado: number;
  disponible: number;
}

export interface IStockPedidoResponse {
  datos: Record<string, IStockProducto>;
  sincronizado: string | null;
  con_stock: boolean;
  // true: no se puede pedir más que el disponible. false: el stock y las alternativas se
  // muestran, pero un producto sin stock igual se puede pedir (PP_BLOQUEAR_SIN_STOCK)
  bloquea_sin_stock: boolean;
}

// Producto al que no le alcanza el stock (respuesta 409 al solicitar o modificar)
export interface IFaltanteStock {
  codigo: string;
  solicitado: number;
  disponible: number;
  stock: number;
  reservado: number;
  sin_registro?: boolean; // el código no figura en la tabla de stock
}

export async function fetchStockPedido(idPc: number): Promise<IStockPedidoResponse> {
  try {
    const { data } = await api.get(`pedido-productos/pedido/${idPc}/stock`);
    return {
      datos: data?.datos || {},
      sincronizado: data?.sincronizado ?? null,
      con_stock: Boolean(data?.con_stock),
      bloquea_sin_stock: Boolean(data?.bloquea_sin_stock),
    };
  } catch (_) {
    // Sin datos de stock la pantalla no restringe cantidades
    return { datos: {}, sincronizado: null, con_stock: false, bloquea_sin_stock: false };
  }
}

// Alternativa con disponible para un producto sin stock (misma familia y atributos
// que tienen que coincidir). Sale de la clasificación del catálogo, no de la IA en vivo.
export interface IAlternativaProducto {
  codigo: string;
  descripcion: string;
  disponible: number;
  precio_unitario: number;
  puntaje: number;
  diferencias: string[];
  cantidad_sugerida: number;
  // Reemplazo que ya se confirmó para este PS: va primero
  confirmada: boolean;
}

export interface IAlternativasResponse {
  codigo: string;
  familia: string | null;
  alternativas: IAlternativaProducto[];
  // Por qué no hay alternativas (sin clasificar, familia sin sugerencias, sin stock)
  motivo: string | null;
}

export async function fetchAlternativasProducto(
  idPc: number,
  codigo: string,
  cantidad: number
): Promise<IAlternativasResponse> {
  try {
    const params = new URLSearchParams({ codigo, cantidad: String(cantidad || 1) });
    const { data } = await api.get(`pedido-productos/pedido/${idPc}/alternativas?${params.toString()}`);
    return data?.datos ?? { codigo, familia: null, alternativas: [], motivo: 'Sin respuesta del servidor' };
  } catch (error: any) {
    return {
      codigo,
      familia: null,
      alternativas: [],
      motivo: error?.response?.data?.error || 'No se pudieron obtener alternativas',
    };
  }
}

// Registra qué hizo el fiscal con las alternativas. Si eligió una (cod_elegido), queda
// como equivalencia confirmada para el PS. cod_elegido null = ninguna le sirvió.
export async function registrarAlternativaProducto(
  idPc: number,
  registro: {
    cod_origen: string;
    cod_elegido: string | null;
    alternativas: string[];
    cantidad?: number;
    disponible_origen?: number;
  }
) {
  try {
    const { data } = await api.post(`pedido-productos/pedido/${idPc}/alternativas`, registro);
    return data;
  } catch (error: any) {
    // No frena al fiscal: el reemplazo en pantalla ya se hizo
    console.error('Error registrando alternativa:', error);
    return { error: error?.response?.data?.error || 'No se pudo registrar la alternativa' };
  }
}

export const fetchGestionJefatura = async () => {
  try {
    const response = await api.get(`pedido-productos/gestion/`);
    const data = response.data; // Ya es un objeto, no necesitas hacer await
    console.log(data);
    // Verificación del estado HTTP
    if (response.status < 200 || response.status >= 300) {
      return {
        error: data?.mensaje ?? 'Ocurrió un error al obtener los productos.' // Mensaje de error más descriptivo
      };
    }

    return data.datos || []; // Retorna los datos o un array vacío si no hay datos

  } catch (error) {
    let errorMessage = 'Ocurrió un error inesperado.';

    // Verifica si el error es una instancia de Error
    if (error instanceof Error) {
      errorMessage = error.message;
    }

    console.error('Error en fetchGestionJefatura:', error);
    return {
      error: errorMessage
    };
  }
};


export const fetchGestionLideres = async () => {
  const response = await api.get("/pedido-productos/gestion-lideres");
  return response.data.datos;
};


export const fetchRechazarPedido = async (id_pc: number) => {
  try {
    const response = await api.delete(`pedido-productos/gestion/${id_pc}/rechazar`);

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to reject order');
    }

    return response.data;
  } catch (error) {
    console.error('Error rejecting order:', error);
    return null;
  }
};

export const fetchCancelarPedido = async (id_pc: number) => {
  try {
    const response = await api.delete(`pedido-productos/pedido/${id_pc}/cancelar`);

    if (response.status >= 300 || response.status <= 199) {
      throw new Error('Failed to cancel order');
    }
    console.log(response.data, 'response.data axios');
    return response.data;
  } catch (error) {
    console.error('Error canceling order:', error);
    return null;
  }
};

export interface RangoPedido {
  fecha_inicio_fiscal: string;
  fecha_fin_fiscal:   string;
  hora_inicio_fiscal: string;
  hora_fin_fiscal:     string;
  fecha_inicio_jefe:  string;
  fecha_fin_jefe:     string;
  hora_inicio_jefe:   string;
  hora_fin_jefe:      string;
  // TD-11079: la ventana de pedidos es por unidad de negocio del punto de servicio
  unidad_negocio_id?: number;
  unidad_negocio?:    string;
  tipo?:              string;   // PRODUCTOS | EPI
}

/**
 * Rango vigente para el punto de servicio indicado. Desde TD-11079 el backend
 * resuelve la unidad de negocio del PS y devuelve la ventana de esa unidad; si
 * esa unidad no tiene rango cargado en EMSYS, `datos` viene vacio.
 */
export const fetchRangoPedido = async (psObjeto?: string, epi = false): Promise<RangoPedido> => {
  const params = new URLSearchParams();
  if (psObjeto) params.set('ps_objeto', psObjeto);
  if (epi) params.set('epi', '1');
  const query = params.toString() ? `?${params.toString()}` : '';
  const resp = await api.get<{ datos: RangoPedido }>(`/pedido-productos/fechas-pedidos/todos${query}`);
  return resp.data.datos;
};

/** Rango vigente de cada unidad de negocio, para las pantallas sin PS en contexto. */
export const fetchRangosPedidoPorUnidad = async (): Promise<RangoPedido[]> => {
  const resp = await api.get<{ por_unidad?: Record<string, RangoPedido> }>(
    '/pedido-productos/fechas-pedidos/todos'
  );
  return Object.values(resp.data.por_unidad || {});
};

// ============================================================================
// Encuesta post-pedido (TD-9465)
// ============================================================================

export interface IEncuestaPregunta {
  id: number;
  orden: number;
  texto: string;
  tipo: string;          // 'SI_NO'
  obligatoria: number;   // 1 | 0
}

export interface IEncuestaPedidoPendiente {
  id_pc: number;
  ps_objeto: string;
  fis_cedula: number;
  fecha: string;
  codigo_referencia: string;
  facturar: number | boolean;
  comodato: number | boolean;
  nuevo_ingreso: number | boolean;
}

export interface IEncuestaPendienteResponse {
  pendiente: boolean;
  pedido?: IEncuestaPedidoPendiente;
  preguntas?: IEncuestaPregunta[];
}

export interface IEncuestaRespuestaInput {
  pregunta_id: number;
  respuesta: 0 | 1;
}

export const fetchEncuestaPendiente = async (
  psObjeto: string
): Promise<IEncuestaPendienteResponse> => {
  try {
    const params = new URLSearchParams({ ps_objeto: psObjeto });
    const { data } = await api.get(`pedido-productos/encuesta/pendiente?${params.toString()}`);
    return (data?.datos as IEncuestaPendienteResponse) ?? { pendiente: false };
  } catch (error) {
    console.error('fetchEncuestaPendiente:', error);
    return { pendiente: false };
  }
};

export const guardarEncuestaPedido = async (
  idPc: number,
  comentario: string | null,
  respuestas: IEncuestaRespuestaInput[]
): Promise<{ info?: string; error?: string; encuesta_id?: number }> => {
  try {
    const response = await api.post(`pedido-productos/encuesta/${idPc}`, {
      comentario,
      respuestas,
    });
    return response.data;
  } catch (error: any) {
    console.error('guardarEncuestaPedido:', error);
    const errResp = error?.response?.data;
    if (errResp) return errResp;
    return { error: 'Ocurrió un error al guardar la encuesta' };
  }
};

export const fetchEncuestaPedido = async (idPc: number) => {
  try {
    const { data } = await api.get(`pedido-productos/encuesta/pedido/${idPc}`);
    return data?.datos ?? null;
  } catch (error) {
    console.error('fetchEncuestaPedido:', error);
    return null;
  }
};


// Importante: el acumulado mensual se usa para validar el tolerado del pedido.
// Regla de negocio: pedidos a facturar (facturar=1) no deben consumir cupo del tolerado normal.
// Por eso se envía `facturar` para que el backend filtre `pc.facturar` y no mezcle consumos.
// Si el tolerado del PS es bimestral o trimestral, el backend acumula los últimos
// 2 o 3 meses y devuelve esa frecuencia (`frecuenciaMeses`).
export async function fetchAcumuladoMes(
  psObjeto: string,
  fechaISO: string,
  excluirId?: number,
  facturar?: boolean | number,
  epi?: boolean | number
) {
  const params = new URLSearchParams({ ps_objeto: psObjeto, fecha: fechaISO });
  if (excluirId) params.append('excluir_id', String(excluirId));
  if (typeof facturar !== 'undefined') {
    const facturarValue = typeof facturar === 'boolean'
      ? (facturar ? '1' : '0')
      : (Number(facturar) ? '1' : '0');
    params.append('facturar', facturarValue);
  }
  // TD-11079: el acumulado de EPIs va aparte del de productos. Si no se envía,
  // el backend lo toma del pedido `excluir_id`.
  if (typeof epi !== 'undefined' && epi !== null) {
    params.append('epi', Number(epi) ? '1' : '0');
  }
  const { data } = await api.get(`pedido-productos/acumulado-mes?${params.toString()}`);
  return {
    acumulado: Number(data?.acumulado_mes ?? 0),
    frecuenciaMeses: Number(data?.frecuencia_meses ?? 1) || 1,
  };
}
